import styled from "styled-components";

export const StyledMyProducts = styled.div`
    .state {
        text-align: center;
        padding: 2rem;
        color: var(--color-text-secondary);
    }

    .state.error {
        color: var(--color-danger);
    }

    .product {
        display: flex;
        flex-direction: column;
        border-bottom: 1px solid #B6B6B6;
        @media (min-width: 992px) {
            flex-direction: row;
        }
    }

    .product-image {
        width: 100%;
        height: 200px;
        overflow: hidden;
        position: relative;
    }

    .product-image img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        transition: transform 0.2s ease;
        display: block;
    }

    .product-content-container {
        text-decoration: none;
    }

    .product-content {
        padding: 1rem 1rem 1rem 2rem;
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    .product-content a {
        text-decoration: none;
    }

    .product-sku {
        font-size: 0.85rem;
        color: var(--color-text-secondary);
        margin-bottom: 0.25rem;
        display: block;
    }

    .product-content h3 {
        margin: 0 0 0.5rem 0;
        color: var(--color-primary);
        font-size: 1.1rem;
        font-weight: 600;
        line-height: 1.3;
    }

    .product-content p {
        margin: 0;
        color: var(--color-text-secondary);
        font-size: 0.9rem;
        line-height: 1.4;
        flex: 1;
    }

    @media (max-width: 768px) {
        .product-image {
            height: 180px;
        }
    }

    @media (max-width: 480px) {
        .product-content {
            padding: 0.75rem;
        }

        .product-content p {
            font-size: 0.85rem;
        }

        .product-content h3 {
            font-size: 1rem;
        }
    }

    .action-link {
        text-decoration: none;
    }
`;


